/**
 * マッチング設定 作成/編集ページ コンテナ
 */
import type React from "react";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  type CreateMatchingConditionInput,
  useCreateMatchingCondition,
  useMatchingCondition,
  useUpdateMatchingCondition,
} from "../../../hooks/use-matching-conditions-api";
import { useWorkspaceMembers } from "../../../hooks/use-workspace-members-api";
import { MatchingConditionFormPage } from "./MatchingConditionFormPage";

/**
 * マッチング設定 作成/編集ページ コンテナ
 * @return {JSX.Element} フォームページ
 */
const MatchingConditionFormPageContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isEdit = !!id;

  const { setting, loading } = useMatchingCondition(id);
  const { createSetting, loading: isCreating } = useCreateMatchingCondition();
  const { updateSetting, loading: isUpdating } = useUpdateMatchingCondition();
  const { members: workspaceMembers } = useWorkspaceMembers();

  const handleSubmit = useCallback(
    async (input: CreateMatchingConditionInput) => {
      if (isEdit && id) {
        await updateSetting(id, input);
      } else {
        await createSetting(input);
      }
      navigate("/settings/matching/conditions");
    },
    [isEdit, id, createSetting, updateSetting, navigate],
  );

  return (
    <MatchingConditionFormPage
      isEdit={isEdit}
      initialData={setting}
      loading={isEdit && loading}
      onSubmit={handleSubmit}
      isSubmitting={isCreating || isUpdating}
      workspaceMembers={workspaceMembers}
    />
  );
};

export default MatchingConditionFormPageContainer;
